import { DisplayService } from "@services/display.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-material";
import { PageStateNames } from "../class/PageStateNames";
import { SettingsName } from "../class/SettingsName";
import { ConstantsService } from "./constantsService";
import { SessionService } from "./session.service";

export class VeriHttpInterceptor {

    connectionErrorDialog: angular.IPromise<any>;
    tokenUrl: string;
    apiUrl: string;

    static Factory($window: angular.IWindowService, $injector: angular.auto.IInjectorService, $q: ng.IQService, $timeout: angular.ITimeoutService, constantsService: ConstantsService) {
        return new VeriHttpInterceptor($window, $injector, $q, $timeout, constantsService);
    }

    constructor(
        private readonly $window: angular.IWindowService,
        private readonly $injector: angular.auto.IInjectorService,
        private readonly $q: ng.IQService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly constantsService: ConstantsService) {
        this.tokenUrl = this.constantsService.getTokenUrl();
        this.apiUrl = this.constantsService.getApiUrl();
    }

    //Method name should be exactly "response" - http://docs.angularjs.org/api/ng/service/$http
    //public response = (response) => {
    //    return response || this.$q.when(response);
    //}

    request = (config: angular.IRequestConfig) => {

        // Auto prepend our API url if we are making an API call
        if (config.url.indexOf("/api/") === 0) {
            config.url = this.apiUrl + config.url;
        }

        // In the future this will be an option / setting
        var keepLoggedIn = true;

        this.setBearerToken(config);

        var responsePromise = this.$q.when(config);

        if (config.method === "POST") {
            responsePromise = responsePromise.then(() => this.$timeout(() => config, 500));
        }

        if (config.url !== this.tokenUrl && keepLoggedIn) {

            const sessionService = this.$injector.get("sessionService") as SessionService;

            if (sessionService.shouldRefreshToken()) {
                responsePromise = sessionService.refreshSession().then(() => {
                    this.setBearerToken(config);

                    return config;
                });
            }
        }

        if (this.connectionErrorDialog != null) {
            this.closeErrorDialog();
        }

        return responsePromise;
    }

    responseError = (rejection: angular.IHttpPromiseCallbackArg<any>) => {

        if (rejection.config?.params?.failureMessage) {
            this.showErrorToast(rejection.config.params.failureMessage);
        }

        if (rejection.status == -1 && this.connectionErrorDialog == null) {
            this.showErrorDialog();
        }
        else if (rejection.status === 401 && !rejection.config.url.endsWith("/token")) {
            console.warn("interceptor 401 forced redirect to login");
            const $state = this.$injector.get("$state") as StateService;
            if ($state.$current.name != PageStateNames.AUTHENTICATION_LOGIN) {
                const sessionService = this.$injector.get("sessionService") as SessionService;
                sessionService.logout();
            }
            else {
                this.$window.location.reload();
            }
        }
        else {
            //const $mdDialog = this.$injector.get("$mdDialog") as angular.material.IDialogService;
            //$mdDialog.hide();

            //const alertDialog = $mdDialog
            //    .alert()
            //    .title("A request failed")
            //    .htmlContent(`One or more HTTP requests have failed.  This is likely due to an unreliable internet connection.<br /><br />\
            //                    If the internet is working correctly then please contact Verilocation support.<br /><br />\
            //                    URL: ${rejection.config.url}<br /><br />\
            //                    ErrorCode: ${rejection.status}`)
            //    .ok("Close");

            //$mdDialog.show(alertDialog);
        }

        // Otherwise, default behavior
        return this.$q.reject(rejection);
    }

    // ---

    private setBearerToken(config: angular.IRequestConfig) {
        const bearer = this.$window.sessionStorage.getItem(SettingsName.AccessToken.toString());
        if (bearer) {
            config.headers["Authorization"] = `Bearer ${bearer}`;
        }
    }

    private getMdDialog(): angular.material.IDialogService {
        return this.$injector.get("$mdDialog") as angular.material.IDialogService;
    }

    private showErrorDialog() {
        ////const $mdDialog = this.getMdDialog();
        ////$mdDialog.hide();

        ////const alertDialog = $mdDialog
        ////    .alert()
        ////    .title("API connection lost")
        ////    .htmlContent(`The connection to the Valkyrie API has been lost, it may be an internet connection issue, please check connectivity.<br /><br />
        ////                        This dialog will close automatically when the connection is restored`)
        ////    .ok("Close");

        ////this.connectionErrorDialog = $mdDialog
        ////    .show(alertDialog)
        ////    .then(() => {
        ////        this.closeErrorDialog();
        ////    });
    }

    private closeErrorDialog() {
        const $mdDialog = this.getMdDialog();
        $mdDialog.hide();
        this.connectionErrorDialog = null;
    }

    private showErrorToast(errorMessage: string) {
        const displayService = this.$injector.get("displayService") as DisplayService;

        displayService.showMessage(errorMessage/*, null, 10_000*/);
    }
}

VeriHttpInterceptor.Factory.$inject = ["$window", "$injector", "$q", "$timeout", "constantsService"];
